import { Navigate, Route, Routes } from 'react-router-dom';

import AppLayout from './layout/AppLayout';
import HomePage from './pages/HomePage';
import SignInPage from './pages/SignInPage';
import RequireSession from './session/RequireSession';

export default function App() {
  return (
    <Routes>
      <Route path="sign-in" element={<SignInPage />} />
      <Route element={<RequireSession />}>
        <Route element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
